/**
 * Work ID list filters are stored (and sent to the API, and read from the URL) as
 * comma-separated strings, while the multiselect dropdowns work with arrays. These two
 * helpers are the single conversion point between the two representations.
 *
 * Work-source values are kept in their `form|<id>` / `name|<url-encoded name>` token form,
 * which is comma-safe because encodeURIComponent escapes commas as %2C.
 */

/** Split a comma-separated filter value into dropdown values. Blank means "no selection". */
export function csvToValues(csv: string | undefined | null): string[] {
  if (!csv) return [];
  return csv
    .split(',')
    .map((v) => v.trim())
    .filter(Boolean);
}

/** Join dropdown values back into the comma-separated filter value. */
export function valuesToCsv(values: (string | number)[]): string {
  return values
    .map((v) => String(v).trim())
    .filter(Boolean)
    .join(',');
}
